<template>
<div class="official-app-content" ref="yaoji-pc">
  <div class="official-banner" id="download-containner">
    <!-- banner轮播 -->
    <el-carousel trigger="click" class="official-custom-carouse">
      <img class="carousel-img" style="width: 100%; opacity: 0;"
      :src="headerList[0] && headerList[0].img" alt="">
      <el-carousel-item v-for="(item, index) in headerList" :key="index">
        <img class="official-carousel-img"
          :src="item.img" alt="">
      </el-carousel-item>
    </el-carousel>
    <!-- banner下载弹窗 -->
    <div class="official-download">
      <div class="official-download-qrcode">
        <div class="official-download-text">
          <img src="../assets/image/download-text.png">
        </div>
        <div class="official-qx">
          <img :src="downloadConfig.ext_info && downloadConfig.ext_info.qrcode">
        </div>
        <div class="official-apple-android">
          <img class="official-apple" @click="onLink('ios')"
            src="../assets/image/pgxz-1.png" style="width: 100%;">
          <img class="official-android" @click="onLink('android')"
            src="../assets/image/azxz-1.png" style="width: 100%;">
        </div>
      </div>
      <div class="official-download-config">
        <div>
          <span>类型：{{downloadConfig.ext_info && downloadConfig.ext_info.type}}</span>
          <span>大小：{{(downloadConfig.ext_info && downloadConfig.ext_info.size) || '--'}}M</span>
        </div>
        <div>
          <span>版本：{{downloadConfig.ext_info && downloadConfig.ext_info.version}}</span>
          <span>安卓版本最低要求：{{downloadConfig.ext_info && downloadConfig.ext_info.min_android_version}}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- 游戏特色 -->
  <div class="yj-special" id="game-containner">
    <div class="yj-topline">
      <div class="yj-customer-server-center-topline">
        <span>游戏特色</span>
      </div>
    </div>
    <div class="yj-introduction">
      <div class="yj-play" @click="gameDesc = 'play';"
        :class=" gameDesc == 'play' ? 'active' : '' ">
        <span>玩法介绍</span>
      </div>
      <div class="yj-comback" @click="gameDesc = 'compete';"
        :class=" gameDesc == 'compete' ? 'active' : '' ">
        <span>赛事介绍</span>
      </div>
    </div>
    <el-carousel v-show="gameDesc == 'play'" :interval="4000" 
      type="card" class="official-custom-activity-carouse">
      <template v-if="gameDesc == 'play'">
        <el-carousel-item v-for="(item, index) in gameList" :key="index">
          <img class="official-carousel-img"
            :src="item.img" alt="">
        </el-carousel-item>
      </template>
    </el-carousel>
    <el-carousel v-show="gameDesc == 'compete'" :interval="4000"
      type="card" class="official-custom-activity-carouse">
      <template v-if="gameDesc == 'compete'">
        <el-carousel-item v-for="(item, index) in activityList" :key="index">
          <img class="official-carousel-img"
            :src="item.img" alt="">
        </el-carousel-item>
      </template>
    </el-carousel>
  </div>
  <div class="yj-fourBlock" id="server-containner">
    <div class="yj-topline">
      <div class="yj-customer-server-center-topline">
        <span>客服中心</span>
      </div>
    </div>
    <div class="official-app-contact-containner" id="app-contact-containner">
      <div class="official-contact-item"
        v-for="(item, index) in serviceList" :key="index">
        <div :class="`official-contact-item-icon ${item.link ? 'icon-cursor' : ''}`"
          @click="onOpen(item)">
          <img :src="item.img" alt="">
        </div>
        <div class="official-contact-item-title">{{item.name}}</div>
        <div class="official-contact-item-content" v-html="renderDesc(item.desc)"></div>
      </div>
    </div>
  </div>
  <div class="line"></div>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { webStat } from 'src/api/fed';
export default {
  data () {
    return {
      gameDesc: 'play',
      statMap: {
        ios: 201,
        android: 202
      }
    };
  },
  methods: {
    renderDesc (desc) {
      let $html = ``;
      let descArr = desc.split('\n');
      descArr.forEach(element => {
        $html += `<div>${element}<div>`;
      });
      return $html;
    },
    onLink (type) {
      this.webStat(type);
      let $type = type === 'android' ? 'android' : this.downloadConfig.ios_status === 0 ? 'enterprise' : 'ios';
      window.open(this.downloadConfig[$type]);
    },
    webStat (type) {
      let params = {
        id: (this.$route.query && this.$route.query.id) || 0,
        origin: 1,
        lid: this.downloadConfig.lid,
        type: this.statMap[type]
      };
      webStat(params);
    },
    onOpen (item) {
      if (item.link) {
        /* eslint-disable */
        ysf('onready', function () {
          ysf('open');
        });
      }
    }
  },
  computed: {
    ...mapGetters(['headerList', 'gameList', 'activityList', 'serviceList', 'downloadConfig'])
  }
}
</script>
<style lang="scss">
.icon-cursor {
  cursor: pointer;
}
</style>
